// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"_33Hlvnt1OuBlsIpCioAdHz"};